import { Component, signal, ViewChild } from '@angular/core';
import { HeaderVersamentoOperazioniMassive} from '../models/operazioni-massive.model';
import { DocumentiSearchDocRow, DocumentiSearchFilters, DocumentiSearchRequest } from 'src/app/shared/models/documento-search.model';
import { Stepper } from 'primeng/stepper';

@Component({
  selector: 'app-versamenti-massiva',
  template:`
    <div class="card card-w-title">
      <p-stepper #stepper [(activeStep)]="activeStep" [linear]="true" orientation="horizontal">
          <p-stepperPanel header="Intestazione">
              <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                <app-stepper-step-header stepTitle="1" stepDescription="Intestazione" [index]="index" [active]="activeStep" (onClick)="onClick.emit()"></app-stepper-step-header>
              </ng-template>        
              <ng-template pTemplate="content" let-nextCallback="nextCallback">
                  <div class="grid">
                    <div class="col-12">
                      <app-intestazione-versamenti (onCompiled)="saveHeader($event)"></app-intestazione-versamenti>
                    </div>
                    <div class="col-12 buttons flex justify-content-end">
                      <button pButton type="button" icon="fas fa-arrow-right" label="Avanti" title="Avanti" (click)="doneSelectedHeader()" class="mr-2"
                        [disabled]="!header"></button>
                    </div>  
                  </div>
              </ng-template>
          </p-stepperPanel>
          <p-stepperPanel  header="Selezione Documenti">
              <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                <app-stepper-step-header stepTitle="2" stepDescription="Selezione Documenti" [index]="index" [active]="activeStep" (onClick)="onClick.emit()"></app-stepper-step-header>
              </ng-template>        
              <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
                <app-ricerca-documenti [baseRequest]="baseRequest" (selected)="selectedDocuments($event)"></app-ricerca-documenti>
                <div class="buttons flex justify-content-end w-full">
                  <button pButton type="button" icon="fas fa-arrow-right" label="Avanti" title="Avanti" (click)="doneSelectedDocument()" class="mr-2 mt-2"
                    [disabled]="!documentToPaymnetSelected.length"></button>
                </div>             
              </ng-template>
          </p-stepperPanel>
          <p-stepperPanel  header="Procedi">
            <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
              <app-stepper-step-header stepTitle="3" stepDescription="Procedi" [index]="index" [active]="activeStep" (onClick)="onClick.emit()"></app-stepper-step-header>
            </ng-template>          
            <ng-template pTemplate="content" let-prevCallback="prevCallback">            
              <app-riepilogo-versamenti *ngIf="header &&  searchDone()" [header]="header" [items]="documentToPaymnetSelected"></app-riepilogo-versamenti>
            </ng-template>
          </p-stepperPanel>
      </p-stepper>
    </div>  
  `
})
export class VersamentiMassivaComponent {
  @ViewChild('stepper', {static: true}) stepper!: Stepper;
  
  public activeStep: number = 0;

  public header : HeaderVersamentoOperazioniMassive | undefined;
  public documentToPaymnetSelected : DocumentiSearchDocRow[] = [];
  public searchDone  = signal<boolean>(false);

  public readonly baseRequest = {
          pageFirstRow: 0,
          includeAllegati: false,
          pageSize: 10,
          sortField: 'Protocollo',
          sortOrder: -1,
          filters: {
            excludeDestroyed:true,
          } as DocumentiSearchFilters
        } as DocumentiSearchRequest;

  public selectedDocuments( items :  DocumentiSearchDocRow[]): void {
    this.documentToPaymnetSelected = [ ...items]
  }

  public doneSelectedHeader(): void {
    if ( this.header) {
      this.activeStep += 1;
    }
  }

  public doneSelectedDocument(): void {
    if ( this.documentToPaymnetSelected.length > 0) {
      this.activeStep += 1;
      this.searchDone.set(true);
    }
  }

  public saveHeader(value: HeaderVersamentoOperazioniMassive | undefined) {
    this.header = undefined;
    if ( value) {
      this.header = { ... value};
    }
  }
  
  public resetHeader() {
    this.header = undefined;
  }
}
